import { Menu } from 'antd'
import checkIcon from 'assets/images/check-mark-16.svg'
import settings from 'popups/Settings'
import React from 'react'
import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import styles from '../SchedulingAssistantTab.module.scss'

interface DurationDropdownProps {
  onDurationChange: (minutes: number) => void
  currentDuration?: number
}

/**
 * DurationDropdown Component
 *
 * Dropdown menu for selecting time duration
 * Used in SchedulingAssistantTab to change selection durations
 * Shows checkIcon next to the currently selected duration
 */
const DurationDropdown = ({ onDurationChange, currentDuration }: DurationDropdownProps) => {
  const { t } = useTranslation()

  // Get current default duration from settings (in minutes)
  // Use as fallback when currentDuration is not provided
  const defaultDuration = settings.getValue('calendar').defaultDuration
  const activeDuration = currentDuration ?? defaultDuration

  const durationOptions = [
    { key: '30', label: t('calendar.duration.30min'), minutes: 30 },
    { key: '60', label: t('calendar.duration.1hour'), minutes: 60 },
    { key: '120', label: t('calendar.duration.2hours'), minutes: 120 },
    { key: '180', label: t('calendar.duration.3hours'), minutes: 180 },
    { key: '240', label: t('calendar.duration.4hours'), minutes: 240 },
  ]

  const menuItems = durationOptions.map((option) => ({
    key: option.key,
    label: (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
          minWidth: '120px',
        }}
      >
        <span>{option.label}</span>
        {option.minutes === activeDuration && <SVG src={checkIcon} className={styles.checkIcon} />}
      </div>
    ),
    onClick: () => onDurationChange(option.minutes),
  }))

  return <Menu items={menuItems} />
}

export default DurationDropdown
